import type { EmailStyleSettings } from "../../style-settings";
import { storedAttributeProps } from "../html-attributes";
import { Text } from "@react-email/components";
import { getParagraphStyles } from "./styles";
export function ParagraphEmailRenderer(attrs: Record<string, unknown>, children?: React.ReactElement, settings?: Partial<EmailStyleSettings>) {
  return <Text {...storedAttributeProps(attrs)} style={getParagraphStyles(attrs, settings)}>
      {children}
    </Text>;
}